module.exports = __webpack_public_path__ + "static/media/review-bg.05ccfb04.png";